import React from "react";
import axios from "axios";
import { Link } from "react-router";
import cx from "classnames";

import FormErrorHandler from "../../components/FormErrorHandler";
import ChapterIndex from "../../components/ChapterIndex";
import { scrollToElem } from "../../functions.js";

export default class CoursesGeneral extends React.Component {
    constructor(props) {
        super(props);

        this.fallbackCloseDialog = this?.props?.fallbackCloseDialog && typeof this.props.fallbackCloseDialog === "function" ? this.props.fallbackCloseDialog : () => true;

        this.state = {
            isPopup: props?.isPopup === true,
            itemID: props.params.itemID !== undefined ? props.params.itemID : "",
            courseID: "",
            dirtyForm: false,
            errorMessage: "",
            trainer: "",
            invoices: [],
            display_name: "",
            competence_profile: "",
            expected_students: "",
            contact_user: "",
            your_reference: "",
            dataCompetenceProfiles: [],
            dataTrainers: [],
            dataContactPersons: []
        };
    }

    updateElementState = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            dirtyForm: true
        });

        if (e.target.name === "trainer") {
            this.getContactPersons(e.target.value);
        }
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        let postData = {
            expected_students: this.state.expected_students,
            your_reference: this.state.your_reference
        };

        await axios
            .patch("/v1/courses/" + this.state.itemID + "/", postData)
            .then((response) => {
                this.props.addGlobalMessage({
                    title: `De gegevens van cursus '${this.state.courseID} - ${this.state.your_reference}' zijn succesvol opgeslagen`,
                    link: `/courses/edit/${this.state.itemID}`
                });
                this.setState({
                    dirtyForm: false
                });
                this.props.router.push(`/courses/edit/${response.data.uuid}/details`);
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    errorMessage: error.response.data
                });
                scrollToElem(document.querySelector(".form-error"));
            });
    };

    getContactPersons = (trainerUUID) => {
        axios
            .get("/v1/trainers/" + trainerUUID + "/users/?pagination=false&fields=uuid,first_name,last_name,last_name_prefix,is_trainer_contact")
            .then((response) => {
                this.setState({
                    dataContactPersons: response.data
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    getTrainerData = () => {
        axios
            .get("/v1/trainers/?fields=uuid,name&pagination=false&is_active=1")
            .then((trainers) => {
                let trainer = trainers.data.length === 1 ? trainers.data[0].uuid : "";
                if (this.state.trainer !== "") {
                    trainer = this.state.trainer;
                }

                if (trainer) {
                    // only have a single trainer, force loading the contact persons because the user can't change the trainers <select>:
                    this.getContactPersons(trainer);
                }

                this.setState({
                    dataTrainers: trainers.data,
                    trainer
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    getCourseData = () => {
        // Get the default data of this competence profile
        axios.get("/v1/courses/" + this.state.itemID + "/").then((course) => {
            this.setState({
                courseID: course.data.id,
                itemID: course.data.uuid,
                trainer: course.data.trainer,
                display_name: course.data.display_name,
                competence_profile: course.data.competence_profile,
                expected_students: course.data.expected_students,
                contact_user: course.data.contact_user,
                your_reference: course.data.your_reference,
                course_state: course.data.state
            });

            axios.get("/v1/courses/" + this.state.itemID + "/invoices/").then((invoices) => {
                this.setState({
                    invoices: invoices.data.results
                });
            });

            this.getContactPersons(course.data.trainer);
        });
    };

    componentDidMount = () => {
        this.getCourseData();
        this.getTrainerData();

        // Get competence profiles to choose from
        axios.get("/v1/competenceprofiles/?fields=uuid,name&is_active=1&pagination=false&ordering=name").then((cp) => {
            this.setState({
                dataCompetenceProfiles: cp.data
            });
        });
    };

    render = () => {
        let competenceprofiles = [];
        if (this.state.competence_profile === "") {
            competenceprofiles.push(
                <option value="" key={"cp-0"}>
                    Kies een competentieprofiel
                </option>
            );
        }
        this.state.dataCompetenceProfiles.forEach((cp) => {
            competenceprofiles.push(
                <option value={cp.uuid} key={`cp-${cp.uuid}`}>
                    {cp.name}
                </option>
            );
        });

        let trainers = [];
        if (this.state.trainer === "") {
            trainers.push(
                <option value="" key={"trainer-0"}>
                    Kies een opleider
                </option>
            );
        }
        this.state.dataTrainers.forEach((trainer) => {
            trainers.push(
                <option value={trainer.uuid} key={`trainer-${trainer.uuid}`}>
                    {trainer.name}
                </option>
            );
        });

        let contactpersons = [];
        if (this.state.dataContactPersons.length === 0) {
            contactpersons.push(
                <option value="" key={"cp-0"}>
                    Kies eerst een opleider
                </option>
            );
        } else {
            contactpersons.push(
                <option value="" key={"contactperson-0"}>
                    Kies een contactpersoon
                </option>
            );
        }

        let selectedContactPerson = "";
        this.state.dataContactPersons.forEach((cp) => {
            selectedContactPerson = cp.uuid === this.props.authentication?.user?.uuid ? cp.uuid : "";

            if (cp.is_trainer_contact) {
                contactpersons.push(
                    <option value={cp.uuid} key={`cp-${cp.uuid}`}>{`${cp.first_name} ${cp.last_name_prefix !== null ? cp.last_name_prefix : ""} ${cp.last_name}`}</option>
                );
            }
        });

        let courseState = false;
        if (["cancelled"].includes(this.state.course_state)) {
            courseState = (
                <div className="form-group">
                    <div className="alert alert-info">Deze cursus is geannuleerd.</div>
                </div>
            );
        }

        return (
            <div>
                {this.state?.isPopup !== true && (
                    <div className="section-top">
                        <div className="breadcrumbs">
                            <Link to={"/courses"}>Cursussen</Link>
                        </div>
                        <h1>
                            <strong>
                                {this.state.courseID} - {this.state.your_reference || "Laden..."}
                            </strong>
                        </h1>
                    </div>
                )}

                <form onSubmit={this.handleSubmit} ref="formref">
                    <div className="row">
                        {this.state?.isPopup !== true && (
                            <div className="col-3 mt-4">
                                <ChapterIndex
                                    chapters={[
                                        { title: "Cursisten", link: "/courses/edit/" + this.props.params.itemID + "/students" },
                                        { title: "Cursusgegevens", link: "/courses/edit/" + this.props.params.itemID + "/details" },
                                        { title: "Downloads", link: "/courses/edit/" + this.props.params.itemID + "/downloads" },
                                        { title: "Facturatie", link: "/courses/edit/" + this.props.params.itemID + "/invoices" }
                                    ]}
                                    isDirty={this.state.dirtyForm}
                                    activeChapter={2}
                                    {...this.props}
                                />
                            </div>
                        )}
                        <div className={cx(this.state?.isPopup !== true ? "col-9" : "col-12", "mt-4")}>
                            {this.state?.isPopup !== true && <h2 className="h1 mb-3">Algemeen</h2>}
                            {this.state.invoices.length > 0 ? (
                                <div className="alert alert-info">Deze cursus bevat al facturen en is daarom niet langer te bewerken</div>
                            ) : (
                                false
                            )}
                            <div className="form-group">
                                <label>
                                    Referentie *{" "}
                                    <span className="lighter">
                                        Hier vul je jouw eigen cursusreferentie in. Op basis van deze omschrijving kun je de bijbehorende cursusadministratie altijd snel
                                        terugvinden in NIBHV Competent.
                                    </span>
                                </label>
                                <input
                                    className="form-control form-control-lg"
                                    type="text"
                                    name="your_reference"
                                    ref="your_reference"
                                    onChange={this.updateElementState}
                                    value={this.state.your_reference}
                                    disabled={this.state.invoices.length > 0}
                                    required
                                />
                                <FormErrorHandler fieldName="your_reference" errorObject={this.state.errorMessage} />
                            </div>
                            <div className="form-group col-4">
                                <label>Verwacht aantal cursisten *</label>
                                <input
                                    className="form-control from-control-md"
                                    type="number"
                                    name="expected_students"
                                    ref="expected_students"
                                    onChange={this.updateElementState}
                                    value={this.state.expected_students}
                                    required
                                />
                                <FormErrorHandler fieldName="expected_students" errorObject={this.state.errorMessage} />
                            </div>
                            <div className="form-group col-12">
                                <label>Competentieprofiel *</label>
                                <select
                                    className="form-control form-control-md"
                                    name="competence_profile"
                                    ref="competence_profile"
                                    onChange={this.updateElementState}
                                    value={this.state.competence_profile}
                                    disabled
                                >
                                    {competenceprofiles}
                                </select>
                                <FormErrorHandler fieldName="competence_profile" errorObject={this.state.errorMessage} />
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Opleider *</label>
                                        <select
                                            className="form-control form-control-md"
                                            name="trainer"
                                            ref="trainer"
                                            onChange={this.updateElementState}
                                            value={this.state.trainer}
                                            required
                                            disabled
                                        >
                                            {trainers}
                                        </select>
                                        <FormErrorHandler fieldName="trainer" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Contactpersoon opleider *</label>
                                        <select
                                            className="form-control form-control-md"
                                            name="contact_user"
                                            ref="contact_user"
                                            onChange={this.updateElementState}
                                            value={this.state.contact_user === "" ? selectedContactPerson : this.state.contact_user}
                                            required
                                            disabled
                                        >
                                            {contactpersons}
                                        </select>
                                        <FormErrorHandler fieldName="contact_user" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3"></div>
                        <div className="col-9">
                            <FormErrorHandler fieldName="all" errorObject={this.state.errorMessage} />

                            {courseState}

                            <div className="form-group">
                                <button
                                    className={cx("btn btn-primary", { "float-right": this.state?.isPopup === true })}
                                    onClick={async (e) => {
                                        e.preventDefault();
                                        await this.handleSubmit(e);
                                        this.fallbackCloseDialog();
                                    }}
                                    type="submit"
                                >
                                    Opslaan
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    };
}
